/**
 * 작업지시서 원시 코드(treatmentType/material) → 사람이 읽는 라벨 변환.
 *
 * BE(china-inapi)는 코드값만 내려준다(예: CROWN, IMPLANT_CROWN, ZIRCONIA) —
 * 번역된 라벨은 응답에 실리지 않으므로 FE가 매핑을 소유해야 한다.
 *
 * Step4.vue(구 SPEC 화면)에 있던 getTreatmentTypeLabel 매핑을 그대로 이관했다 —
 * 새 화면(ManualWorkOrders.vue, DealerDashboard.vue)이 같은 어휘를 다시
 * 선언하면 치료유형이 추가될 때 두 곳을 따로 고쳐야 하므로 이 파일이 단일 소유자다.
 *
 * 컴포넌트 밖(순수 함수)에서 i18n에 접근하는 패턴은 src/apis/geo.js,
 * src/apis/ecountEtl.js 를 따른다 — `import i18n from '@/i18n'` 후 i18n.global.t() 호출.
 */
import i18n from '@/i18n';

// key는 BE 원시 코드의 소문자형 — Step4.vue 원본과 동일하게 소문자로 매칭한다.
const TREATMENT_TYPE_KEY_MAP = {
  crown: 'workorder_surgery_crown',
  implant_crown: 'workorder_surgery_implant_crown',
  bridge: 'workorder_surgery_bridge',
  laminate: 'workorder_surgery_laminate',
  inlay: 'workorder_surgery_inlay',
  onlay: 'workorder_surgery_onlay',
  veneer: 'workorder_surgery_veneer',
};

const MATERIAL_KEY_MAP = {
  zirconia: 'workorder_form_zirconia',
};

/**
 * treatmentType 코드(대소문자 무관) → 번역 라벨.
 * 매핑에 없는 코드는 원값을 그대로 반환한다(빈 값 방지, 신규 코드 무표시 방지).
 * @param {string|undefined|null} treatmentType
 * @returns {string}
 */
export function getTreatmentTypeLabel(treatmentType) {
  const key = TREATMENT_TYPE_KEY_MAP[treatmentType?.toLowerCase()];
  return key ? i18n.global.t(key) : treatmentType || '';
}

/**
 * material 코드(대소문자 무관) → 번역 라벨.
 * 매핑에 없는 코드는 원값을 그대로 반환한다.
 * @param {string|undefined|null} material
 * @returns {string}
 */
export function getMaterialLabel(material) {
  const key = MATERIAL_KEY_MAP[material?.toLowerCase()];
  return key ? i18n.global.t(key) : material || '';
}
